var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "ground",
            "title": "솔루션",
            "src": "/images/sub/subvisual-solution.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first",
    scopedSlots: _vm._u([{
      key: "titleLine",
      fn: function fn() {
        return [_vm._v(" 스마트팜 제품 솔루션 ")];
      },
      proxy: true
    }])
  }, [_c('tit-wrap-large', {
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_vm._v(" 인위적인 환경 관리가 힘든 노지재배에서 작물이 필요로 하는 적정한 물과 영양분 공급으로 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("효율적인 토양재배환경 관리가 가능하며 농작물 재배의 효율과 생산성을 높여줍니다. "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("노지재배 환경과 근권부(작물의 뿌리 주변) 환경을 지속적으로 모니터링하여 필요 영양분 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("공급과 관수제어로 최적의 생육환경을 유지할 수 있습니다. ")];
      },
      proxy: true
    }])
  }, [_vm._v(" 토양환경 데이터를 취득하여 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("작물이 필요한 요소를 측정하는 "), _c('b', [_vm._v("노지스마트팜")])])], 1), _c('v-container', [_c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('page-section', [_c('page-section', {
    staticClass: "page-section--sm py-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          staticClass: "mx-n20px my-n10px mx-md-n30px my-md-n20px"
        }, [_c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-left",
            "data-aos-delay": "200"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 570 / 456,
            "content-class": "d-flex"
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "570",
            "aspect-ratio": 570 / 456,
            "src": "/images/sub/solution/smartfarm/ground-img.jpg"
          }
        })], 1)], 1)], 1), _c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-right",
            "data-aos-delay": "200"
          }
        }, [_c('div', [_c('tit-wrap-sprout', {
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" 작물재배 토양 데이터 취득 장비 ")];
            },
            proxy: true
          }])
        }, [_vm._v(" 노지 스마트팜 ")]), _c('txt-item', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("측정항목")];
            },
            proxy: true
          }])
        }, [_vm._v(" 외부 온도, 습도, 일사 / 토양의 온도, 습도, EC, 수분 ")]), _c('div', {
          staticClass: "mt-16px mt-md-24px"
        }, [_c('v-img', {
          attrs: {
            "max-width": "436",
            "aspect-ratio": 436 / 272,
            "src": "/images/sub/solution/smartfarm/ground-img2.png"
          }
        })], 1)], 1)])], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-card', {
          attrs: {
            "rounded": "",
            "color": "grey lighten-5",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 1200 / 770,
            "content-class": "d-flex align-center justify-center"
          }
        }, [_c('div', {
          staticClass: "pa-30px pa-md-40px px-lg-80px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": "600",
            "width": _vm.$vuetify.breakpoint.lgAndUp ? '600' : '',
            "aspect-ratio": 600 / 376,
            "src": "/images/sub/solution/smartfarm/ground-img3.png"
          }
        }), _c('div', {
          staticClass: "pt-30px pt-md-40px pt-lg-60px"
        }, [_c('tit-wrap-small', {
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v("작물재배 토양의 정보를 웹과 모바일에서 간편하게 모니터링이 가능합니다.")];
            },
            proxy: true
          }])
        }, [_vm._v(" 웹과 모바일에서 쉽고 간편한 실시간 모니터링 ")])], 1)], 1)])], 1)];
      },
      proxy: true
    }])
  })], 1), _c('v-container', [_c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('page-section', {
    staticClass: "page-section--last",
    attrs: {
      "id": "ground-portfolio"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v(" 포트폴리오 ")];
      },
      proxy: true
    }, {
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('div', {
          staticClass: "mx-auto px-12px",
          staticStyle: {
            "max-width": "1480px"
          }
        }, [_c('ground-slide')], 1)];
      },
      proxy: true
    }])
  }, [_c('div')])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }